import { Christmas } from "./pages/christmas/Christmas";

function App() {
  return (
    <>
      <Christmas />
    </>
  );
}

export default App;
